up.Change.DestroyFragment = class DestroyFragment extends up.Change {
    constructor(options) {
        super(options);
        this._layer = up.layer.get(options) || up.layer.current;
        this._element = this.options.element;
        this._animation = this.options.animation;
        this._log = this.options.log;
    }
    execute() {
        this._parent = this._element.parentNode;
        up.fragment.markAsDestroying(this._element);
        up.animate(this._element, this._animation, {
            ...this.options,
            onFinished: () => {
                this._erase();
                this._emitDestroyed();
                this.options.onFinished?.();
            }
        });
    }
    _erase() {
        this._layer.asCurrent(() => {
            up.fragment.abort(this._element);
            up.script.clean(this._element, { layer: this._layer });
            this._element.remove();
        });
    }
    _emitDestroyed() {
        up.fragment.emitDestroyed(this._element, { parent: this._parent, log: this._log });
    }
};
